import 'client-only';

import { type FormEventHandler, useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { useVisitContext } from '@/services/visitsService/hooks/useVisitContext';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

import { logEligibilityFailure } from '../utils';
import {
  type EligibilityFormErrors,
  EligibilityFormSchema,
} from '../utils/validation';

export const useVisitEligibilityForm = () => {
  const { brand } = useFlowContext();
  const { visit } = useVisitContext();
  const navigation = useNavigation();
  const [errors, setErrors] = useState<EligibilityFormErrors>();
  const [processing, setProcessing] = useState(false);

  const submit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();

    if (!visit) {
      console.error('Visit is not defined');
      return;
    }

    const formData = new FormData(e.currentTarget);

    const validated = EligibilityFormSchema.safeParse(
      Object.fromEntries(formData),
    );

    if (!validated.success) {
      setErrors(validated.error.flatten());
      return;
    }

    setProcessing(true);

    try {
      await post(urls[brand].api.visits.eligibility.store(visit?.uuid), {
        state: validated.data.state || '',
        hasAcceptedTerms: validated.data.hasAcceptedTerms,
        birthdate: validated.data.birthdate,
      });
      navigation.onNext();
    } catch (error: any) {
      logEligibilityFailure(error);
      setProcessing(false);
      return;
    }

    setProcessing(false);
  };

  return {
    submit,
    processing,
    errors,
  };
};
